import { Injectable, inject } from '@angular/core';

import { ApiService } from '@frontend/sports/common/api-utils';
import { SeoConfig } from '@frontend/sports/common/client-config-data-access';
import { SimpleCallback } from '@frontend/sports/common/core/utils/extended-types';
import { TimerService } from '@frontend/sports/common/core/utils/timer';
import { DeviceService } from '@frontend/vanilla/core';
import { clone } from 'lodash-es';
import { finalize } from 'rxjs';

export interface LogRecord {
    source: string;
    url: string;
}

@Injectable({ providedIn: 'root' })
export class SeoLoggerService {
    private device = inject(DeviceService);
    private api = inject(ApiService);
    private timer = inject(TimerService);
    private seo = inject(SeoConfig);

    private records: LogRecord[] = [];
    private recordsTimer?: SimpleCallback;

    log(record: LogRecord): void {
        if (!this.device.isRobot || !this.seo.isClientCatchallLoggingEnabled) {
            return;
        }

        this.records.push(record);

        if (this.recordsTimer) {
            return;
        }

        this.recordsTimer = this.timer.setTimeout(() => {
            this.api
                .post('seo/log', { records: clone(this.records) })
                .pipe(
                    finalize(() => {
                        this.records.splice(0);
                        this.recordsTimer = undefined;
                    }),
                )
                .subscribe();
        }, this.seo.clientLoggingDebounce);
    }
}
